import React, { useState } from 'react';

interface ProjectImageProps {
  src?: string;
  alt: string;
  className?: string;
}

/**
 * ProjectImage component that displays project image or TKB placeholder
 * If no image is provided, shows a styled "TKB" text placeholder
 */
const ProjectImage: React.FC<ProjectImageProps> = ({ src, alt, className = '' }) => {
  const [imageError, setImageError] = useState(false);
  const shouldShowPlaceholder = !src || !src.trim() || imageError;

  if (shouldShowPlaceholder) {
    // TKB placeholder
    return (
      <div
        className={`${className} flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-700 dark:from-primary-600 dark:to-primary-900`}
      >
        <span className="text-white font-bold text-4xl tracking-wider drop-shadow-lg">
          TKB
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setImageError(true)}
    />
  );
};

export default ProjectImage;
